module.exports = __webpack_public_path__ + "img/front_body.5a9a2c9c.svg";